import React, { useState } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import PageHeader from '../../../common/page-header';
import Paper from '@mui/material/Paper';
import moment from "moment";

import {
    Backdrop,
    Button,
    Card,
    CircularProgress,
    Divider,
    List,
    Box,
    Modal,
    IconButton,
    ListItemIcon,
    ListItem,
    ListItemText,
    TextField,
    Typography
} from "@mui/material";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    maxHeight: '80vh',
    borderRadius: '8px',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
};




function EmergencyContact() {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    const handleSubmit = (event) => {
        event.preventDefault();

        handleClose();
    };



    return (
        <div>
            <PageHeader title={`Emergency Contact `} />
            <div className='flex' style={{ width: '100', display: 'flex', justifyContent: "end", marginRight: 10 }}>
                < Button variant="contained" sx={{ width: "200px", }}
                    onClick={handleOpen} >Add Emergency Contact</Button >
            </div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography id="modal-modal-title" variant="h4" component="h2" sx={{ textAlign: "center", pb: 5 }}>
                        Emergency Contact Form
                    </Typography>
                    <form onSubmit={handleSubmit}>


                        <TextField
                            id="text-input"
                            label="Contact Name"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            required
                            sx={{ mt: 2 }}
                            autoFocus
                        />

                        <TextField
                            id="text-input"
                            label="Phone Number"
                            variant="outlined"
                            fullWidth
                            margin="normal"
                            required
                            sx={{ mt: 2 }}
                        />
                        <TextField
                            id="text-input"
                            label="Relationship"
                            variant="outlined"
                            required
                            fullWidth
                            margin="normal"
                            sx={{ mt: 2 }}
                        />
                        <div style={{ display: "flex", justifyContent: "end" }}>
                            <Button
                                variant="contained"
                                type="submit"
                                sx={{
                                    mt: 2, mr: 2,
                                    background: "gray",
                                    '&:hover': {
                                        backgroundColor: 'gray',
                                    },
                                }}
                                onClick={handleClose}
                            >
                                Cancel
                            </Button>

                            <Button variant="contained" type="submit" sx={{ mt: 2 }}>
                                Submit
                            </Button>

                        </div>
                    </form>

                </Box>
            </Modal>
            <Card sx={{ mt: 5 }} variant="outlined">
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell>NO</TableCell>
                                <TableCell>Contact Name</TableCell>
                                <TableCell>Phone Number</TableCell>
                                <TableCell>Relationship
                                </TableCell>
                                <TableCell> </TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>

                            <TableRow

                                sx={{ '&:last-child td, &:last-child th': { border: 0 }, marginTop: 5 }}
                            >
                                <TableCell>1</TableCell>
                                <TableCell>Akhil
                                </TableCell>
                                <TableCell>00986756343</TableCell>
                                <TableCell> Developer of SpiderWorks</TableCell>
                                <TableCell>delete</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>

            </Card>

        </div >
    )
}

export default EmergencyContact
